"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTextColumnInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class FreeTextColumnInternalApi extends ApiBase_1.ApiBase {
    /**
     * Checks if a User Edit was in a Free Text Column
     * @param cellDataChangedInfo change to check
     */
    handleFreeTextColumnDataChange(cellDataChangedInfo) {
        let freeTextColumn = this.getFreeTextColumnApi()
            .getFreeTextColumns()
            .find((fc) => fc.ColumnId == cellDataChangedInfo.column.columnId);
        if (freeTextColumn) {
            let freeTextStoredValue = {
                PrimaryKey: cellDataChangedInfo.primaryKeyValue,
                FreeText: cellDataChangedInfo.newValue,
            };
            this.getFreeTextColumnApi().setStoredValue(freeTextColumn.ColumnId, freeTextStoredValue);
            var colsToRefresh = [cellDataChangedInfo.column.columnId];
            const refencedCalcColumns = this.adaptable.api.calculatedColumnApi.internalApi.getCalculatedColumnsReferencingColumnId(cellDataChangedInfo.column.columnId);
            refencedCalcColumns.forEach((calculatedColumn) => {
                colsToRefresh.push(calculatedColumn.ColumnId);
            });
            this.adaptable.refreshCells([cellDataChangedInfo.rowNode], colsToRefresh, false);
        }
    }
    /**
     * Returns all the references in the AdaptableState of the given FreeTextColumn
     * @param freeTextColumn FreeTextColumn to be checked
     */
    getFreeTextColumnModuleReferences(freeTextColumn) {
        const references = [];
        this.adaptable.adaptableModules.forEach((module) => {
            if (module
                .getModuleFreeTextColumnReferences()
                .some((moduleReference) => moduleReference.Uuid === freeTextColumn.Uuid)) {
                references.push(module.moduleInfo.FriendlyName);
            }
        });
        return references;
    }
}
exports.FreeTextColumnInternalApi = FreeTextColumnInternalApi;
